export enum SettingsCompanionDataEventObjectsEnum {
  FROYO_MANAGE_SOURCES = 'froyo_manage_sources',
  FROYO_CREATE_PLAYBOOK = 'froyo_create_playbook',
  BREADCRUMB = 'breadcrumb',
}
